<template>
  <div class="px-6 px-sm-0">
    <div
      class="
        secondary--text
        d-flex
        justify-center
        text-h4
        font-italic
        text-uppercase
        font-weight-black
        pb-8
      "
    >
      Faça sua cotação
    </div>
    <v-form
      @submit="onSubmit"
      ref="form"
      :action="this.server + this.$route.fullPath"
      id="form-contact"
      v-model="valid"
      lazy-validation
    >
      <label for="name">Nome</label>
      <v-text-field
        id="name"
        dense
        outlined
        name="name"
        :rules="nameRules"
        required
      ></v-text-field>
      <label for="email">E-mail</label>
      <v-text-field
        id="email"
        dense
        outlined
        name="email"
        :rules="emailRules"
        required
      ></v-text-field>

      <label for="tel">Telefone</label>
      <v-text-field
        id="tel"
        dense
        outlined
        name="tel"
        :rules="telRules"
        required
        v-mask="['(##) ####-####', '(##) #####-####']"
      ></v-text-field>

      <label for="message">Mensagem:</label>
      <v-textarea
        id="message"
        dense
        outlined
        name="message"
        :rules="messageRules"
        required
        no-resize
      ></v-textarea>

      <v-checkbox
        name="policy_privacy"
        v-model="policy_privacy"
        :rules="[(v) => !!v || 'Você precisa aceitar para continuar.']"
        required
        value="1"
        class="mt-0 policy-privacy"
      >
        <template v-slot:label>
          <div class="open-sans">
            Eu li e concordo com a
            <a class="primary--text" @click="showPrivacy">
              Política de Privacidade.
            </a>
          </div>
        </template>
      </v-checkbox>

      <div class="text-center">
        <v-btn
          :loading="loadingForm"
          class="white--text py-4 px-12 mt-2 font-weight-bold primary rounded-0"
          type="submit"
          depressed
          width="100%"
          height="48px"
        >
          Enviar
        </v-btn>
      </div>

      <v-snackbar :color="color" centered v-model="snackbar" :multi-line="true">
        {{ response }}

        <template v-slot:action="{ attrs }">
          <v-btn
            color="white"
            text
            v-bind="attrs"
            @click="snackbar = false"
            icon
          >
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
    </v-form>
  </div>
</template>
<script>
import { mask } from "vue-the-mask";
export default {
  directives: { mask },
  data: () => ({
    response: "",
    color: "success",
    loadingForm: false,
    snackbar: false,
    valid: true,
    nameRules: [(v) => !!v || "Digite seu nome."],
    telRules: [(v) => !!v || "Digite seu telefone."],
    emailRules: [
      (v) => !!v || "Digite seu e-mail.",
      (v) => /.+@.+\..+/.test(v) || "Digite um e-mail válido.",
    ],
    messageRules: [(v) => !!v || "Digite sua mensagem."],
    policy_privacy: false,
  }),
  computed: {
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    md() {
      return this.$vuetify.breakpoint.mdOnly;
    },
    mdAndDown() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
  },
  methods: {
    showPrivacy: () => window.showPrivacyPolicy(),
    onSubmit(event) {
      const form = document.getElementById("form-contact");
      if (this.$refs.form.validate()) {
        this.loadingForm = true;
        const formData = new FormData(form);
        const action = `${this.server}/rest/email/contact-us`;
        fetch(action, {
          method: "POST",
          body: formData,
        })
          .then((r) => {
            if (r.ok) {
              if (window.dataLayer) {
                window.dataLayer.push({ event: "form_submit_contact-us" });
              }
              this.$router.push("/obrigado");
            } else {
              this.response =
                "OPS! tivemos um problema no envio das informações, tente novamente mais tarde.";
              this.color = "red accent-2";
              this.snackbar = true;
              this.loadingForm = false;
            }
          })
          .catch(() => {
            this.response =
              "OPS! tivemos um problema no envio das informações, tente novamente mais tarde.";
            this.color = "red accent-2";
            this.snackbar = true;
            this.loadingForm = false;
          });
      }
      event.preventDefault();
    },
  },
};
</script>
<style>
.v-text-field fieldset,
.v-text-field .v-input__control,
.v-text-field .v-input__slot {
  border-radius: 0px !important;
}
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0 !important;
  padding: 0 !important;
}
.v-text-field__slot {
  max-height: 100px;
}
@media (max-width: 1300px) {
  .v-text-field__slot {
    max-height: 70px;
  }
  .v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
    line-height: 15px;
  }
}
@media (min-width: 1300px) {
  .v-text-field__slot {
    max-height: 100px;
  }
  .v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
    line-height: 15px;
  }
}
#form-contact {
  width: 100%;
  font-family: "Open Sans", sans-serif !important;
  color: #2b292a;
  font-size: 14px;
}
.policy-privacy .v-input__slot {
  background-color: transparent !important;
}
.v-input__slot {
  background-color: rgb(255, 255, 255) !important;
}
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  box-shadow: none !important;
}
.form-bg .v-btn {
  border-radius: 0 !important;
}
</style>
